<template>
    <div class="inner-wrapper">
        <div class="alert alert-success" role="alert" v-if="successMessage">
            {{ successMessage }}
        </div>

        <!--<div class="page-title">
            <h1 class="float-left">Quotations</h1>
            <div class="title-right float-right">

            </div>
        </div>-->
        <div class="new-rfq">
            <fieldset class="customer-search mb-3">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-auto">
                                <form class="form-inline list-search" action="">
                                    <div class="filter-sec">
                                        <button type="button" class="btn filter-btn" @click="showFilters=!showFilters">
                                            <i class="ri-filter-line align-bottom me-1"></i> Filters
                                        </button>
                                    </div>
                                    <span class="listbtn-sec">
                                        <a href="javascript:void(0)" class="btn list-btn"
                                        @click="changeView(true)"
                                        :class="{'active': isListView == true}"><i class="ri-list-check align-bottom"></i></a>
                                        <a href="javascript:void(0)" class="btn list-btn"
                                        @click="changeView(false)"
                                        :class="{'active': isListView == false}"><i class="ri-grid-fill align-bottom"></i></a>
                                    </span>

                                </form>
                            </div>
                            <div class="col-lg-3 col-auto">
                                <form class="form-inline list-search"  @submit.prevent="search()">

                                    <div class="input-group">
                                        <div class="input-group-append">
                                            <button class="btn btn-success" type="button" @click.prevent="search"><i class="ri-search-line search-icon"></i></button>
                                        </div>
                                        <input v-model="filterData.search_filter" type="text" class="form-control"
                                            placeholder="Quick Search">

                                    </div>

                                </form>
                            </div>
                            <div class="col-auto ms-sm-auto">
                                <div class="btnrow float-right">
                                    <div class="d-flex align-items-center">
                                    <router-link v-if="quotationData.can_add_quotation" :to="{ name: 'addQuotePage'}"
                                                class="btn create-btn">
                                        <i class="ri-add-circle-line align-bottom me-1"></i> Add RFQ
                                    </router-link>
                                    <div class="quotes-text">{{ quotationData.count }} Quotes</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="filter-row" v-if="showFilters">
                    <div class="form-group" v-if="quotationData.status">
                        <select class="form-control" v-model="filterData.status" @change="search">
                            <option :value="null">Status</option>
                            <option v-for="(status, index) in quotationData.status" :value="status.id">
                                {{ status.name }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group" v-if="quotationData.sale_users">
                        <select class="form-control" v-model="filterData.user_id" @change="search">
                            <option :value="null">Sales REP</option>
                            <option v-for="(sale_user, index) in quotationData.sale_users" :value="sale_user.id">
                                {{ sale_user.name }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <select class="form-control" v-model="filterData.cus_id" @change="search">
                            <option :value="null">Added By</option>
                            <option v-for="(admin_user, index) in quotationData.admin_users" :value="admin_user.id">
                                {{ admin_user.name }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <select class="form-control" v-model="filterData.date_filter" @change="search">
                            <option :value="null">Time Frame</option>
                            <option value="0">All Time</option>
                            <option value="1">Today</option>
                            <option value="2">This week</option>
                            <option value="3">This Month</option>
                            <option value="4"> This Year</option>
                            <option value="5">Custom Range</option>
                        </select>
                    </div>
                    <div class="search-btnsec dl-flex">
                        <button class="btn btn-success" type="button" v-on:click="search"><i class="ri-search-line search-icon"></i>
                        </button>
                        <button class="btn btn-reset" type="reset" @click="resetFilter"><i class="ri-refresh-line"></i>
                        </button>
                    </div>
                </div>
                <div class="row" v-if="showFilters">
                    <div class="col-md-3">
                        <date-picker v-if="filterData.date_filter == 5" format="MM/DD/YYYY" @change="search"
                                     v-model="filterData.date_range" range></date-picker>
                    </div>
                </div>
            </fieldset>

            <template v-if="isListView">
                <QuotationList :current_page="current_page"
                               :total="total"
                               :per_page="per_page"
                               :user_type="quotationData.user_type"
                               :role="quotationData.role"
                               :can_delete_quotation="quotationData.can_delete_quotation"
                               :quotations="quotationData.quotations"
                               @onDeleteMultiple="deleteMultiple"
                               @deleteItem="deleteQuotation"
                               @changeCurrentPage="changeCurrentPage"
                               @onApproveQuotations="approveQuotations"></QuotationList>
            </template>
            <template v-else>
                <QuotationGrid :loadedScrollAllPage="loadedScrollAllPage"
                               :quotationData="quotationData"
                               @changePriority="changePriority"
                               @deleteItem="deleteQuotation"
                               @changeScrollGridItem="changeScrollGridItem"
                               @changeScrollPage="changeScrollPage"
                               @changeStatusEvent="changeStatusEvent"></QuotationGrid>
            </template>


        </div>

        <footer class="footer">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-sm-6">
                                2022 © Superb.
                            </div>
                            <div class="col-sm-6">
                                <div class="text-right d-none d-sm-block">
                                    All Rights Reserved.
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>


    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import Vue from "vue";
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import {debounce, merge} from 'lodash';

import QuotationList from "../../components/QuotationList";
import QuotationGrid from "../../components/QuotationGrid";
import {EventBus} from "../../event-bus";

export default {
    name: "Quotations",
    components: {
        DatePicker,
        QuotationList, QuotationGrid
    },
    created() {
        window.addEventListener('beforeunload', this.beforePageUnload);

        EventBus.$on('resetQuoteFilter', this.resetFilter);
    },
    beforeRouteLeave (to, from , next) {
        //console.log(to)
        if(to.name == 'viewQuote') {
            let quotationFilters = {
                isListView: this.isListView,
                showFilters: this.showFilters,
                filterData: this.filterData
            }
            this.setQuotationsFilter(quotationFilters);

        } else {
            let quotationFilters = {
                isListView: this.isListView,
                showFilters: false,
                filterData: {
                    search_filter: null,
                    date_filter: null,
                    user_id: null,
                    status: null,
                    tab: null,
                    customer_id: null,
                    date_range: null,
                    type: null,
                    cus_id: null,
                    start: null,
                    end: null,
                    customer_user: null
                },
            }
            this.setQuotationsFilter(quotationFilters);
        }
        next();
    },
    beforeMount() {
        this.setCommonErrors([]);
        this.setErrorMessage(null);
        this.setSuccessMessage(null);

        if(this.quotationFilters) {
            this.showFilters = this.quotationFilters.showFilters;
            this.filterData = this.quotationFilters.filterData;
        }

        let q_filter_type = localStorage.getItem('q_filter_type');
        let q_filter_cus_id = localStorage.getItem('q_filter_cus_id');
        let q_filter_start = localStorage.getItem('q_filter_start');
        let q_filter_end = localStorage.getItem('q_filter_end');
        if(typeof q_filter_type != undefined && q_filter_type != null && q_filter_type != '' &&
            typeof q_filter_cus_id != undefined && q_filter_cus_id != null && q_filter_cus_id != '' &&
            typeof q_filter_start != undefined && q_filter_start != null && q_filter_start != '' &&
            typeof q_filter_end != undefined && q_filter_end != null && q_filter_end != '') {

            /*this.showFilters = true;
            this.isListView = true;
            this.forceListView = true;*/

            // this.filterData.type = q_filter_type;
            //this.filterData.cus_id = q_filter_cus_id;
            /*if(q_filter_type == 'status') {
                this.filterData.status = q_filter_cus_id;
            } else if(q_filter_type == 'customer') {
                this.filterData.customer_user = q_filter_cus_id;
            }
            else if(q_filter_type == 'admin') {
                this.filterData.cus_id = q_filter_cus_id;
                this.filterData.start = q_filter_start;
                this.filterData.end = q_filter_end;
                //this.filterData.date_range.start_date = q_filter_start;
                //this.filterData.date_range.end_date = q_filter_end;
            }*/
            // this.filterData.start = q_filter_start;
            // this.filterData.end = q_filter_end;
            //this.filterData.date_filter = 5;
            //this.filterData.date_range = [ q_filter_start, q_filter_end];

            localStorage.removeItem('q_filter_type');
            localStorage.removeItem('q_filter_cus_id');
            localStorage.removeItem('q_filter_start');
            localStorage.removeItem('q_filter_end');
        }


        /*setTimeout(() => {
            this.search()
        }, 500);*/
    },
    mounted() {
        this.getQuotations();
    },
    data() {
        return {
            bus: new Vue(),
            isListView: false,
            forceListView: false,
            totalOrders: 0,
            showFilters: false,
            filterData: {
                search_filter: null,
                date_filter: null,
                user_id: null,
                status: null,
                tab: null,
                customer_id: null,
                date_range: null,
                type: null,
                cus_id: null,
                start: null,
                end: null,
                customer_user: null
            },
            quotationData: {
                quotations: null,
                reminder_quote: null,
                type: null,
                notify: null,
                adminNotification: null,
                OtherNotification: null,
                DesktopNotification: null,
                cus_id: null,
                start: null,
                end: null,
                count: null,
                config: null,
                quotations_data: null,
                status: null,
                sale_users: null,
                quote_time: null,
                active_tab: 'one',
                admin_users: null,
                check_filter: null,
                can_add_quotation: false,
                can_delete_quotation: false,
                user_type: null,
                role: null
            },
            current_page: 1,
            per_page: 10,
            total: 0,
            scrollPage: 1,
            loadedScrollAllPage: 0,
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomerLoading',
            'setLoading',
            'setQuotationsFilter'
        ]),
        beforePageUnload() {
            this.filterData = {
                search_filter: null,
                date_filter: null,
                user_id: null,
                status: null,
                tab: null,
                customer_id: null,
                date_range: null,
                type: null,
                cus_id: null,
                start: null,
                end: null,
                customer_user: null
            };
            let quotationFilters = {
                isListView: this.isListView,
                showFilters: this.showFilters,
                filterData: this.filterData
            }
            this.setQuotationsFilter(quotationFilters);
        },
        resetFilter() {
            this.filterData = {
                search_filter: null,
                date_filter: null,
                user_id: null,
                status: null,
                tab: null,
                customer_id: null,
                date_range: null,
                type: null,
                cus_id: null,
                start: null,
                end: null,
                customer_user: null
            };
            let quotationFilters = {
                isListView: this.isListView,
                showFilters: this.showFilters,
                filterData: this.filterData
            }
            this.setQuotationsFilter(quotationFilters);

            this.search();
        },
        approveQuotations(id) {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            return axios.post(window.route('ApproveQuotations'), {id: id}, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        self.setSuccessMessage(data.data);
                        self.getQuotations();
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        changeView(value) {
            this.isListView = value;
            this.current_page = 1;
            this.scrollPage = 1;
            if(this.isListView) {
                this.search();
            } else {
                this.scrollPage = 1;
                this.loadedScrollAllPage = 0;
                this.getQuotations(this);
            }

        },
        setTotalOrders(event) {
            this.totalOrders = event;
        },
        changeCurrentPage(current_page) {
            //console.log("dddd",current_page);
            this.current_page = current_page;
        },
        changeScrollGridItem(event) {
            //console.log(event)
            this.itemLoadMore(this, event.item);
        },
        changeScrollPage(scrollPage) {
            this.scrollPage = scrollPage;
            if( this.scrollPage > 1) {
                this.loadMore(this);
            }
        },
        changeStatusEvent(event) {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('changeQuoteStatus'), event, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        self.setSuccessMessage(data.data);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        self.getQuotations();


                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        changePriority(event) {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('quotes.changePriority', event), {}, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        self.setSuccessMessage(data.message);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        self.getQuotations();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        deleteQuotation(event) {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('deleteQuote'), event, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        self.setSuccessMessage(data.message);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        self.getQuotations();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        deleteMultiple(selectedQuotesForDelete){
            //console.log(selectedQuotesForDelete);
            if(selectedQuotesForDelete.length == 1) {
                this.deleteQuotation(selectedQuotesForDelete[0]);
            } else {
                let self = this;
                this.setLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);
                return axios.post(window.route('deleteSelectedQuotes'), {ids: selectedQuotesForDelete}, {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                    .then(({data}) => {
                        if (data.errorMessage) {
                            self.setErrorMessage(data.errorMessage);
                            if (data.errors) {
                                self.setCommonErrors(data.errors);
                            }
                        } else {
                            self.setSuccessMessage(data.message);
                            setTimeout(() => {
                                self.setSuccessMessage(null);
                            }, 5000);
                            self.getQuotations();
                        }
                    })
                    .catch((error) => {
                        self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                    })
                    .finally(() => {
                        self.setLoading(false);

                    });
            }
        },
        getQuotations() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('quotations.index', {
                _query: {
                    is_draft: 0,
                    search_filter: this.filterData.search_filter,
                    date_filter: this.filterData.date_filter,
                    user_id: this.filterData.user_id,
                    status: this.filterData.status,
                    //tab: this.filterData.tab,
                    tab: this.quotationData.active_tab,
                    customer_id: this.filterData.customer_id,
                    date_range: this.filterData.date_range,
                    type: this.filterData.type,
                    cus_id: this.filterData.cus_id,
                    start: this.filterData.start,
                    end: this.filterData.end,
                    customer_user: this.filterData.customer_user,
                    isListView:this.isListView
                }
            }), this.filterData, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.quotationData = data.data;

                        if(this.forceListView) {
                            // this.isListView = true;
                        } else {
                            // this.isListView = this.quotationData.active_tab != 'one';
                        }

                        this.current_page = data.data.quotations.current_page;
                        this.per_page = data.data.quotations.per_page;
                        this.total = data.data.quotations.total;

                        if(data.data.check_filter) {
                            // this.filterData = data.data.check_filter
                        }

                        // this.search();
                        if(this.filterData) {
                            if(this.filterData.search_filter ||
                                this.filterData.date_filter ||
                                this.filterData.user_id ||
                                this.filterData.status ||
                                this.filterData.customer_id ||
                                this.filterData.date_range ||
                                this.filterData.type ||
                                this.filterData.cus_id ||
                                this.filterData.start ||
                                this.filterData.end ||
                                this.filterData.customer_user) {
                                this.search();
                            }

                        }

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        search() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('quotations.ajaxLoad', {
                _query: {
                    page: this.current_page,
                    is_draft: 0,
                    tab: this.quotationData.active_tab,
                    isListView:this.isListView
                }
            }), this.filterData, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.quotationData.quotations = data.data.quotations;
                        this.quotationData.quote_time = data.data.quote_time;
                        if(data.data.count) {
                            this.quotationData.count = data.data.count;
                        }
                        this.quotationData.config = data.data.config;
                        this.quotationData.quotations_data = data.data.quotations_data;

                        if(data.data.active_tab) {
                            // this.quotationData.active_tab = data.data.active_tab;
                        }

                        this.current_page = data.data.quotations.current_page;
                        this.per_page = data.data.quotations.per_page;
                        this.total = data.data.quotations.total;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        loadMore: debounce((vm) => {
            vm.setLoading(true);
            vm.setCommonErrors([]);
            vm.setErrorMessage(null);
            return axios.post(window.route('status.ajaxLoadOnScroll', {
                _query: {
                    page: vm.scrollPage,
                    is_draft: 0
                }
            }), vm.filterData, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        vm.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            vm.setCommonErrors(data.errors);
                        }
                    } else {
                        if (data.data.quotations_data.new.data.length == 0 &&
                            data.data.quotations_data.price_approve.data.length == 0 &&
                            data.data.quotations_data.save_price.data.length == 0 &&
                            data.data.quotations_data.sent_customer.data.length == 0 &&
                            data.data.quotations_data.sent_vendor.data.length == 0) {
                            vm.loadedScrollAllPage = 1;
                            return;
                        }
                        // vm.quotationData.quotations_data = data.data.quotations_data;
                        vm.quotationData.quotations_data.new.data = vm.quotationData.quotations_data.new.data.concat(data.data.quotations_data.new.data);
                        vm.quotationData.quotations_data.price_approve.data = vm.quotationData.quotations_data.price_approve.data.concat(data.data.quotations_data.price_approve.data);
                        vm.quotationData.quotations_data.save_price.data = vm.quotationData.quotations_data.save_price.data.concat(data.data.quotations_data.save_price.data);
                        vm.quotationData.quotations_data.sent_customer.data = vm.quotationData.quotations_data.sent_customer.data.concat(data.data.quotations_data.sent_customer.data);
                        vm.quotationData.quotations_data.sent_vendor.data = vm.quotationData.quotations_data.sent_vendor.data.concat(data.data.quotations_data.sent_vendor.data);

                        // vm.quotationData.quote_time = data.data.quote_time;
                        vm.quotationData.quote_time.new = [...vm.quotationData.quote_time.new, ...data.data.quote_time.new];
                        vm.quotationData.quote_time.price_approve = [...vm.quotationData.quote_time.price_approve, ...data.data.quote_time.price_approve];
                        vm.quotationData.quote_time.save_price = [...vm.quotationData.quote_time.save_price, ...data.data.quote_time.save_price];
                        vm.quotationData.quote_time.sent_customer = [...vm.quotationData.quote_time.sent_customer, ...data.data.quote_time.sent_customer];
                        vm.quotationData.quote_time.sent_vendor = [...vm.quotationData.quote_time.new, ...data.data.quote_time.sent_vendor];

                        if(data.data.count) {
                            vm.quotationData.count = data.data.count;
                        }
                    }
                })
                .catch((error) => {
                    vm.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    vm.setLoading(false);

                });
        }, 350),

        itemLoadMore: debounce((vm, item = null) => {
            if(vm.quotationData.quotations_data[item].current_page < vm.quotationData.quotations_data[item].last_page) {
                vm.quotationData.quotations_data[item].current_page += 1;
            } else {
                return false;
            }

            vm.setLoading(true);
            vm.setCommonErrors([]);
            vm.setErrorMessage(null);
            return axios.post(window.route('status.ajaxLoadOnItemScroll', {
                _query: {
                    page: vm.quotationData.quotations_data[item].current_page,
                    item: item,
                    is_draft: 0
                }
            }), vm.filterData, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        vm.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            vm.setCommonErrors(data.errors);
                        }
                    } else {

                        /*if(item == 'new') {

                        } else if(item == 'sent_vendor') {

                        } else if(item == 'save_price') {

                        } else if(item == 'sent_customer') {

                        } else if(item == 'price_approve') {

                        }*/

                        // vm.quotationData.quotations_data[item].data = vm.quotationData.quotations_data.new.data.concat(data.data.quotations_data[item].data);
                        vm.quotationData.quotations_data[item].data = vm.quotationData.quotations_data[item].data.concat(data.data.quotations_data[item].data);

                        vm.quotationData.quote_time[item] = [...vm.quotationData.quote_time[item], ...data.data.quote_time[item]];
                    }
                })
                .catch((error) => {
                    vm.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    vm.setLoading(false);

                });
        }, 350),

    },
    watch: {
        current_page: {
            handler: function (value) {
                
               // if (value != 1) {
                    this.search();
               // }
            }
        },
        isListView: {
            handler: function (value) {
                let quotationFilters = {
                    isListView: value,
                    showFilters: this.showFilters,
                    filterData: this.filterData
                }
                this.setQuotationsFilter(quotationFilters);
            }
        },
        showFilters: {
            handler: function (value) {
                let quotationFilters = {
                    isListView: this.isListView,
                    showFilters: value,
                    filterData: this.filterData
                }
                this.setQuotationsFilter(quotationFilters);
            }
        },
        filterData: {
            handler: function (value) {
                let quotationFilters = {
                    isListView: this.isListView,
                    showFilters: this.showFilters,
                    filterData: value
                }
                this.setQuotationsFilter(quotationFilters);
            },
            deep: true
        }
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading',
            'quotationFilters'
        ])
    }
}
</script>

<style scoped>

</style>
